(function () {
  'use strict';
  var script = document.currentScript;
  var SECTION_ID = script && script.dataset.sectionId;
  var root = document.getElementById('acs-' + SECTION_ID);
  if (!root) return;

  if (script && script.dataset.headingAnim === 'stack') {
  // Split-Stack-Reveal für die Überschrift — direkter Port aus dem Upgrade
  // Hero (initStackReveal): identische Duplikat-Zeilen in einem exakt eine
  // Zeile hohen, geclippten Fenster; alle Buchstaben wandern mit Stagger
  // nach oben, bis die letzte Zeile im Fenster landet. Einmalig, kein
  // ScrollTrigger. Der Theme-Editor rendert den Abschnitt bei jeder
  // Änderung neu, daher Teardown von Timelines/Splits vor jedem Lauf.
  if (root.__acsStackCleanup) root.__acsStackCleanup();
  var stackSplits = [];
  var stackTimelines = [];
  var headline = root.querySelector('.acs-headline[data-reveal-style="stack"]');

  function revealStackMarks() {
    if (!headline) return;
    Array.prototype.forEach.call(
      headline.querySelectorAll('.academy-pill-mark'),
      function (el) { el.classList.add('is-revealed'); }
    );
  }

  function stackTeardown() {
    stackTimelines.forEach(function (tl) { tl.kill(); });
    stackTimelines = [];
    stackSplits.forEach(function (s) { try { s.revert(); } catch (e) { /* element evtl. schon entfernt */ } });
    stackSplits = [];
  }
  root.__acsStackCleanup = stackTeardown;

  function initStack() {
    if (!headline) return;
    if (typeof gsap === 'undefined' || typeof SplitText === 'undefined') {
      headline.style.opacity = 1;
      revealStackMarks();
      return;
    }

    var wrapper = headline.querySelector('.acs-headline__stack-rows');
    var rows = wrapper ? Array.prototype.slice.call(wrapper.querySelectorAll('.acs-headline__stack-row')) : [];
    if (!wrapper || !rows.length) { headline.style.opacity = 1; return; }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Fensterhöhe muss exakt eine gerenderte Zeilenhöhe sein (variiert mit
    // der Schriftgröße pro Breakpoint) — daher zur Laufzeit gemessen,
    // aufgerundet, damit oben kein Rest der nächsten Zeile durchblitzt.
    var rowHeight = Math.ceil(rows[0].getBoundingClientRect().height);
    wrapper.style.height = rowHeight + 'px';
    headline.style.opacity = 1;

    if (reduceMotion) { revealStackMarks(); return; }

    var totalRows = rows.length;
    var splitRows = rows.map(function (row) {
      // Wörter UND Buchstaben splitten: der Per-Buchstabe-Tween braucht
      // die Char-Spans, aber sie in nicht-umbrechende Wort-Spans zu
      // gruppieren (siehe .acs-headline__stack-word) verhindert den
      // Umbruch mitten im Wort ("LEVEL" -> "L / EVEL").
      var rs = SplitText.create(row, {
        type: 'words,chars',
        wordsClass: 'acs-headline__stack-word',
        charsClass: 'acs-headline__stack-char'
      });
      stackSplits.push(rs);
      return rs.chars;
    });
    var maxChars = Math.max.apply(null, splitRows.map(function (c) { return c.length; }));
    // Absolute Pixel (nicht yPercent): jeder Buchstabe legt dieselbe echte
    // Distanz zurück, unabhängig von seiner eigenen Boxhöhe.
    var moveDistance = rowHeight * (totalRows - 1);
    // Feste 0.05 s Char-Stagger — identisch zum Upgrade Hero
    // (initStackReveal), damit der Flip 1:1 gleich aussieht.
    var charStagger = 0.05;

    var tl = gsap.timeline({ delay: 0.1 });
    stackTimelines.push(tl);

    for (var i = 0; i < maxChars; i++) {
      splitRows.forEach(function (chars, rowIndex) {
        var letter = chars[i];
        if (!letter) return;
        tl.to(letter, { y: -moveDistance, duration: 0.8, ease: 'power4.inOut' }, i * charStagger + rowIndex * 0.05);
      });
    }

    tl.call(function () {
      revealStackMarks();
      // Duplikat-Zeilen existierten nur, um während des Flips hinter dem
      // Clip zu verschwinden — danach entfernen, damit das permanente
      // overflow: hidden weg kann.
      var lastRow = rows[rows.length - 1];
      rows.forEach(function (row) { if (row !== lastRow) row.remove(); });
      gsap.set(lastRow.querySelectorAll('.acs-headline__stack-char'), { clearProps: 'transform' });
      wrapper.style.overflow = 'visible';
      wrapper.style.height = 'auto';
    });
  }

  // animations.min.js lädt am Ende von <body>, daher gsap-Check erst bei
  // DOMContentLoaded (analog zur Haupt-Slider-Logik oben).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStack);
  } else {
    initStack();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail && event.detail.sectionId === SECTION_ID) stackTeardown();
  });
  }

  if (script && script.dataset.buttonStyle === 'upgrade') {
  // Touch/Geräte ohne :hover — die Hover-Choreografie des Upgrade-Buttons
  // einmal als "Schau hier"-Hinweis abspielen, wenn er ins Bild scrollt.
  var cta = root.querySelector('.acs-cta--upgrade');
  if (cta) {
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var ctaReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canHover && !ctaReduceMotion && 'IntersectionObserver' in window) {
      var ctaIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          ctaIO.unobserve(entry.target);
          var el = entry.target;
          setTimeout(function () { el.classList.add('is-revealed'); }, 300);
          setTimeout(function () { el.classList.remove('is-revealed'); }, 1600);
        });
      }, { threshold: 0.8 });
      ctaIO.observe(cta);
    }
  }
  }
})();
